module.exports = __webpack_public_path__ + "img/book@3x.a5cae8cb.png";